import { useAppSelector } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { selectUserInfo } from "store/user/userSlice"
import { CATEGORY_ROUTES, isTryOnCategory } from "@/features/home/categoryLinks"
import { selectCategoriesLoading, selectSelectedCategories } from "store/product/productSlice"

export const CategoryAccessLayout: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { username } = useAppSelector(selectUserInfo)
  const selectedCategories = useAppSelector(selectSelectedCategories)
  const categoriesLoading = useAppSelector(selectCategoriesLoading)
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    if (!username) {
      setIsChecking(false)
      navigate("/login", { replace: true })
      return
    }

    if (categoriesLoading) return
    const pathSegments = location.pathname.split("/").filter(Boolean)
    const basePath = `/${pathSegments[0]}`

    // Only routes of categories the merchant selected on Home are reachable;
    // everything else (including an empty selection) goes back to /home.
    const allowedPaths = selectedCategories
      .filter(isTryOnCategory)
      .map((key) => CATEGORY_ROUTES[key].list)

    if (!allowedPaths.includes(basePath)) navigate("/home", { replace: true })

    setIsChecking(false)
  }, [username, selectedCategories, categoriesLoading, location.pathname, navigate])

  if (isChecking || categoriesLoading)
    return <div className="flex h-screen w-screen items-center justify-center" />

  return <Outlet />
}
